import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Shared, on-brand "coming soon" page for features that are not built yet.
 * Replaces bare `<h1>X</h1><p>Coming Soon.</p>` pages that read as broken.
 */
export default function ComingSoon({ title = 'Coming soon', blurb }) {
  return (
    <div
      style={{
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '48px 20px',
        background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%)',
        color: '#fff',
        fontFamily: '"Poppins", sans-serif',
      }}
    >
      <div style={{ maxWidth: 560 }}>
        <div style={{ fontSize: '3.5rem', marginBottom: 16 }}>🛠️</div>
        <h1 style={{ fontSize: '2rem', marginBottom: 12 }}>{title}</h1>
        <p style={{ opacity: 0.75, lineHeight: 1.6, marginBottom: 28 }}>
          {blurb || 'We are building this feature. Check back soon.'}
        </p>
        <Link
          to="/"
          style={{
            padding: '12px 24px',
            background: 'linear-gradient(135deg, #FE5500, #ff7a00)',
            borderRadius: 8,
            color: '#fff',
            fontWeight: 500,
            textDecoration: 'none',
          }}
        >
          Back to Homepage
        </Link>
      </div>
    </div>
  );
}
